import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getTypes = store => store[NAME].types;
export const getAlertInfo = store => store[NAME].alertInfo;
export const getMessageModalIsOpen = store => store[NAME].messageModalIsOpen;
export const getLocale = store => store[NAME].locale;
export const getDateFormat = store => store[NAME].dateFormat;